import React, { Component } from 'react';
import { Field } from 'redux-form';
import LabelAndSelectForm from '../common/form/labelAndSelectForm';

class SelectMes extends Component {
  renderRows() {
    const list = [
      { id: 1, desc: 'Janeiro' },
      { id: 2, desc: 'Fevereiro' },
      { id: 3, desc: 'Março' },
      { id: 4, desc: 'Abril' },
      { id: 5, desc: 'Maio' },
      { id: 6, desc: 'Junho' },
      { id: 7, desc: 'Julho' },
      { id: 8, desc: 'Agosto' },
      { id: 9, desc: 'Setembro' },
      { id: 10, desc: 'Outubro' },
      { id: 11, desc: 'Novembro' },
      { id: 12, desc: 'Dezembro' },
    ];

    return list.map(mes => (
      <option key={mes.id} value={mes.id}>
        {mes.desc}
      </option>
    ));
  }

  render() {
    return (
      <Field
        name="mes"
        component={LabelAndSelectForm}
        label="Mês"
        cols={this.props.cols}
        hideLabel={this.props.hideLabel}
        validate={this.props.validate}
        onChange={this.props.onChange}
      >
        <option value="">Selecione</option>
        {this.renderRows()}
      </Field>
    );
  }
}

export default SelectMes;
